<template>
<div class="general-edit-text">
  <div v-if="!isEditing" class="d-flex align-items-center">
    <span class="text-truncate" :title="inputValue">{{ inputValue }}</span>
    <div class="d-inline-block clickable lighter ml-3" @click="isEditing = true">
      <icon type="edit" size="1" />
    </div>
  </div>
  <div v-else>
    <input
        v-model="inputValue"
        type="text"
        class="form-text form-text-dark d-inline-block"
        @keydown.enter="save"
    />
    <div @click="save" class="d-inline-block ml-2 clickable">
      <icon type="save" />
    </div>
    <div @click="close" class="d-inline-block ml-2 clickable">
      <icon type="times" />
    </div>
  </div>
</div>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  name: "GeneralEditText",
  components: {
    Icon,
  },
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: null },
    isDisabled: { type: Boolean, default: false },
    isRequired: { type: Boolean, default: false },
    isReadonly: { type: Boolean, default: false },
  },
  data() {
    return {
      inputValue: this.value,
      isEditing: false,
    };
  },
  beforeMount() {
    this.setValue();
  },
  methods: {
    setValue() {
      this.inputValue = this.value;
    },
    save() {
      this.$emit("updateValue", this.inputValue);
      this.isEditing = false;
    },
    close() {
      this.isEditing = false;
      this.inputValue = this.value;
    },
  }
}
</script>

<style scoped lang="scss">
.general-edit-text {
  .form-text {
    width: 60%;
  }
}
</style>